export default __webpack_public_path__ + "static/media/list.092214d5.svg";